module.exports = __webpack_public_path__ + "static/media/Placaj-Ceramic-Klinker-250-X-65-X-10---Montan-(13).dbba52c5.jpg";